<template>
  <el-dialog title="选择打印模板" :visible.sync="dialogVisible" width="700px" append-to-body>
    <div v-if="choosePkg" style="margin-bottom: 30px;">
      需要打印的批次包：
      <el-radio-group v-model="choosePkgCode">
        <el-radio :label="item.pkgCode" v-for="item, index in choosePkg" :key="index" style="margin:5px">
          {{ `${item.amount}个${item.flowTagName}(${item.pkgCode})` }}
        </el-radio>
      </el-radio-group>
    </div>
    <div>
      打印模板：
      <el-radio-group v-model="templateCode">
        <el-radio-button :label="item.templateCode" v-for="item, index in templateList" :key="index">
          {{ item.templateName || `模板${item.templateCode}` }}
        </el-radio-button>
      </el-radio-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { templatePrintByJSON } from "@/utils/print";
import { printListByType, listPkgDetail } from "@/apis/outStock";
export default {
  name: "choosePrint",
  props: {
  },
  data() {
    return {
      dialogVisible: false,
      templateList: [],
      printData: [],
      templateCode: '',
      choosePkg: null,
      choosePkgCode: null
    }
  },
  mounted() {
  },
  methods: {
    templatePrintByPkg(Arr, choosePkg = null) {
      console.log(Arr, choosePkg)
      this.templateList = []
      this.templateCode = ''
      this.printData = Arr
      this.choosePkg = choosePkg
      this.choosePkgCode = null
      choosePkg && (this.choosePkgCode = choosePkg[0].pkgCode)
      this.getTemplate(1)
    },
    async submit() {
      if (this.templateCode) {
        let templateJson = ''
        templateJson = this.templateList.filter(item => { return item.templateCode == this.templateCode })[0].templateJson
        let params = this.choosePkgCode ? [this.choosePkgCode] : this.printData.map(item => item.pkgCode)
        let res = await listPkgDetail(params)
        let printData = []
        let nodata = []
        function dataFormat(data) {
          const main = data.additionalList?.map((v) => {
            let text = v.additionWithIngredientProp + (v.additionExtraName ? `:${v.additionExtraName}` : '')
            return text
          }).join()
          // 汇总并去重所有子商品的非空加料名称
          const sub = Array.from(new Set(data?.combinationChildAdditionList?.reduce((pre, cur) => {
            return pre.concat(cur?.additionalList?.map((v) => v.additionName ?? '').filter(Boolean) ?? [])
          }, []) ?? [])).join()
          const nData = {
            ...data,
            additionalListNames: (main ? `【主】${main}` : '') + (sub ? `【子】${sub}` : ''),
            additionWithIngredientGrid: data.additionalList?.map((v) => {
              let text = v.additionWithIngredientGrid + (v.additionExtraName ? `:${v.additionExtraName}` : '')
              return text
            }).join(),
            additionOnlyNames: data.additionalList?.map((v) => {
              let text = v.additionName + (v.additionExtraName ? `:${v.additionExtraName}` : '')
              return text
            }).join(),
            systemSource: data.systemSource == 1 ? 'D2C' : data.systemSource == 2 ? 'B2B' : `系统来源${data.systemSource}`,
            specialFlag: data.specialFlag == 1 ? '特' : '',
            ingredientsFlag: data.ingredientsFlag == 1 ? '辅' : '',
            combinationProductItemFlag: data.combinationProductItemFlag == 1 ? '组' : '',
            customerTag: data.customerTag == 1 ? '重' : data.customerTag == 2 ? '重-非' : '',
            ingredientType: data.ingredientType == 1 ? '质检辅料' : data.ingredientType == 2 ? '成品辅料' : '',
            crossDockingFlag: data.crossDockingFlag ? '越' : ''
          }
          return nData
        }
        if (this.choosePkgCode) {
          if (JSON.stringify(res.data[0]) === "{}" || !res.data[0].pkgCode) {
            nodata.push(this.choosePkgCode)
          } else {
            let choosePkgItem = this.choosePkg.filter(i => i.pkgCode == this.choosePkgCode)[0]
            for (let i = 0; i < choosePkgItem.amount; i++) {
              printData.push(dataFormat(res.data[0]))
            }
          }
        } else {
          this.printData.forEach((item, index) => {
            if (JSON.stringify(res.data[index]) === "{}" || !res.data[index].pkgCode) {
              nodata.push(item.pkgCode)
            } else {
              if (item.wantPrintNum) {
                for (let i = 0; i < item.wantPrintNum; i++) {
                  printData.push(dataFormat(res.data[index]))
                }
              } else {
                printData.push(dataFormat(res.data[index]))
              }
            }
          })
        }
        if (nodata.length > 0 && printData.length > 0) {
          this.$confirm(`
          <div>确认打印其余批次包,以下为无批次包信息${nodata.map(i => `<div>${i}</div>`).join('')}</div>
          `, "提示", {
            confirmButtonText: "确认",
            type: "error",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
          }).then(() => {
            templatePrintByJSON(templateJson, printData)
            this.dialogVisible = false
          });
        } else if (nodata.length > 0 && printData.length == 0) {
          this.$confirm(`<div>无批次包信息${nodata.map(i => `<div>${i}</div>`).join('')}</div>`, "提示", {
            confirmButtonText: "确认",
            type: "error",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
          }).then(() => {
            this.dialogVisible = false
          });
        } else {
          templatePrintByJSON(templateJson, printData)
          this.dialogVisible = false
        }
      } else {
        this.$message.warning('请选择模板')
      }
    },
    getTemplate(type) {
      printListByType({ type: type }).then(({ code, data }) => {
        if (code === 0) {
          if (data.length > 0) {
            this.templateList = data;
            this.dialogVisible = true
            this.templateCode = data[0].templateCode
          } else {
            this.$message.warning('请配置模板')
          }
        }
      });
    },
    open(options) {
      this.printData = options
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped></style>
